import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HourglassLoaderComponent } from './hourglassloader.component'

@NgModule({
    imports: [CommonModule],
    declarations: [HourglassLoaderComponent],
    exports: [HourglassLoaderComponent],
})
export class HourglassLoaderModule {}
